var React = require('react');

function MentorMono (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16,8l-1.8-2l0.2-2.7l-2.6-0.6l-1.4-2.3L8,1.4l-2.5-1L4.2,2.7L1.5,3.3L1.8,6L0,8l1.8,2l-0.2,2.7l2.6,0.6\n\tl1.4,2.3l2.4-1l2.5,1.1l1.4-2.3l2.6-0.6L14.2,10L16,8z M9.9,8.8l0.7,3L8,10.2l-2.6,1.6l0.7-2.9l-2.3-2l3-0.3L8,3.8l1.2,2.7l3,0.3\n\tL9.9,8.8z","fill":"currentColor"}));
}

MentorMono.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = MentorMono;

MentorMono.default = MentorMono;
